import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import AuthContext from "../../../context/auth/AuthContext";
import { previewPushAudience } from "../../../services/push-notifications";
import { pushNotificationKeys } from "../queryKeys";

const usePushAudiencePreview = (request, enabled = false) => {
  const { tenant } = useContext(AuthContext);
  const tenantCode = tenant?.code;
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: pushNotificationKeys.preview(tenantCode, request),
    queryFn: ({ signal }) => previewPushAudience({ request, signal }),
    enabled: Boolean(tenantCode && enabled && request),
    staleTime: 0,
  });

  return {
    ...query,
    previewNow: (nextRequest = request) =>
      queryClient.fetchQuery({
        queryKey: pushNotificationKeys.preview(tenantCode, nextRequest),
        queryFn: ({ signal }) =>
          previewPushAudience({ request: nextRequest, signal }),
        staleTime: 0,
      }),
  };
};

export default usePushAudiencePreview;
